/**
 *
 * @author Matthew Rawson @ 02/05/2018 10:02
 * @description
 * @notes
 */
import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import id from "@irati/utils/id"
import {numToWords} from "@irati/utils/number/numberToWords"
import {pluralise} from "@irati/utils/grammar"


const WeekPeriod = ({schedule, property, ...props}) => {
  const idNamespace = id("WeekPeriod", props)
  const weekPeriod = get(schedule, property)

  return <span id={idNamespace}>{numToWords(weekPeriod)} {pluralise("week", weekPeriod)}</span>
}

WeekPeriod.propTypes = {
  schedule: PropTypes.object,
  property: PropTypes.string
}
WeekPeriod.defaultProps = {
  schedule: {},
  property: "periodValue"
}

export default WeekPeriod
